export enum EmployeeVisitsView {
  List = 'ListEmployeeVisits',
  CreateWizard = 'CreateEmployeeVisitsWizard',
  EditWizard = 'EditEmployeeVisitsWizard',
  SignatureWizard = 'SignaturesWizard',
}
